import styled from "styled-components";

export const Wrap = styled.div`
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  @media (min-width: 990px) {
    margin-right: -24px;
    margin-left: -24px;
    padding-right: 24px;
    padding-left: 24px;
    box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.08);
  }
`;

export const Paragraph = styled.p`
  margin: 0 0 2px 0;
  padding: 0;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: -0.26px;
  clear: both;
  user-select: none;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Numbers = styled.b`
  display: block;
  float: right;
  padding: 2px 4px;
  border-radius: 12px;
  border: solid 1px #e6e6e6;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: center;

  b {
    color: var(--color-primary);
  }

  b.simple {
    color: initial;
  }

  b.active {
    color: var(--color-secondary);
  }
`;